import React, { useEffect } from 'react';
import { navigate } from 'gatsby';
import { useDispatch, useSelector } from 'react-redux';
import { CenteredLayout } from 'src/public/components/CenteredLayout';
import { isAuthenticatedSelector } from 'src/state/auth/authSelectors';
import { isPlatformBrowser } from 'src/lib/isPlatformBrowser';
import { CompanyConfirmationHeader } from 'src/public/components/company-confirmation/CompanyConfirmationHeader';
import { LandingRoute } from 'src/public/publicRoutes';
import { AppRoute } from 'src/app/routes';
import { CompanyConfirmationLogo } from 'src/public/components/company-confirmation/CompanyConfirmationLogo';
import { CompanyConfirmationMain } from 'src/public/components/company-confirmation/CompanyConfirmationMain';
import { CompanyConfirmationViewState } from 'src/common/models/companyConfirmationViewState';
import { CompanyConfirmationEmail } from 'src/public/components/company-confirmation/CompanyConfirmationEmail';
import { CompanyConfirmationSuccess } from 'src/public/components/company-confirmation/CompanyConfirmationSuccess';
import { CompanyConfirmationFailure } from 'src/public/components/company-confirmation/CompanyConfirmationFailure';
import {
  companyConfirmationViewStateSelector,
  needConfirmationSelector,
} from 'src/state/companyConfirmation/companyConfirmationSelectors';
import { companyConfirmationViewActions } from 'src/state/companyConfirmation/companyConfirmationActions';
import { useStorePageUrl } from 'src/common/hooks/useStorePageUrl';

const CompanyConfirmationPage = () => {
  useStorePageUrl();

  const dispatch = useDispatch();

  const companyConfirmationViewState = useSelector(
    companyConfirmationViewStateSelector
  );
  const isLoggedIn = useSelector(isAuthenticatedSelector);
  const needConfirmation = useSelector(needConfirmationSelector);

  const renderView = (view: CompanyConfirmationViewState) => {
    switch (view) {
      case CompanyConfirmationViewState.Email:
        return <CompanyConfirmationEmail />;
      case CompanyConfirmationViewState.Failure:
        return <CompanyConfirmationFailure />;
      case CompanyConfirmationViewState.SuccessChange:
      case CompanyConfirmationViewState.SuccessConfirmation:
        return <CompanyConfirmationSuccess />;
      default:
        return <CompanyConfirmationMain />;
    }
  };

  useEffect(() => {
    return () => {
      dispatch(
        companyConfirmationViewActions.resetCompanyConfirmationViewState()
      );
    };
  }, []);

  if (
    isPlatformBrowser() &&
    companyConfirmationViewState !== CompanyConfirmationViewState.Failure
  ) {
    if (!isLoggedIn || !needConfirmation) {
      navigate(LandingRoute);
      return null;
    }

    if (!needConfirmation) {
      navigate(AppRoute);
      return null;
    }
  }

  return (
    <CenteredLayout>
      <div>
        <CompanyConfirmationLogo />
        <CompanyConfirmationHeader />

        {renderView(companyConfirmationViewState)}
      </div>
    </CenteredLayout>
  );
};

// eslint-disable-next-line import/no-default-export
export default CompanyConfirmationPage;
